import React, { useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import flow from 'lodash/fp/flow';
import { Box, Button, Checkbox, FormControlLabel, Stack, Typography } from '@mui/material';
import { translate } from 'translations/translator';
import { useModal } from '@lwtears/lwt-common-frontend/lib/Modal';
import other_edition_cover_image from 'assets/images/2025-edition-covers.png';
import { getUser, saveUserSetting } from 'state/modules/user/thunks';
import { AppStoreState, SETTING_TYPES, UserSetting } from 'types';

const tHome = (key: string, options?) => translate('home', key, options);

type Props = {
  switchAction: () => void;
  saveUserSetting: (type: string, setting: UserSetting) => void;
};

const SwitchEditionModal: React.FC<Props> = ({ switchAction, saveUserSetting }) => {
  const [, { closeModal }] = useModal();
  const dispatch = useDispatch() as any;

  const [shouldSuppressMessage, setShouldSuppressMessage] = useState<boolean>(false);

  const suppressMessage = async () => {
    setShouldSuppressMessage(!shouldSuppressMessage);

    await saveUserSetting(SETTING_TYPES.SUPPRESS_2025_SWITCH, !shouldSuppressMessage);
    await dispatch(getUser());
  };

  return (
    <Box sx={styles.modal}>
      <Box sx={{ textAlign: 'center', width: '100%' }}>
        <Box component={'img'} sx={styles.img} src={other_edition_cover_image} />
      </Box>
      <Stack gap="16px" padding="32px">
        <Box sx={{ textAlign: 'left' }}>
          <Typography variant="h4Heavy" sx={styles.text}>
            {tHome('switchEditionMessage')}
          </Typography>
        </Box>
        <FormControlLabel
          control={<Checkbox onChange={suppressMessage} />}
          label={tHome('suppressMessage')}
          sx={{
            margin: '0 !important',
            '& .MuiTypography-root': {
              marginTop: '2px'
            }
          }}
        />
        <Box sx={styles.buttonContainer}>
          <Button variant="outlined" onClick={closeModal} aria-label={tHome('CANCEL')}>
            <Typography variant="body2">{tHome('cancel')}</Typography>
          </Button>
          <Button variant="contained" onClick={switchAction} aria-label={tHome('YES')}>
            <Typography variant="body2">{tHome('yes')}</Typography>
          </Button>
        </Box>
      </Stack>
    </Box>
  );
};

const styles = {
  modal: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    maxWidth: '426px'
  },
  img: {
    width: '100%'
  },
  text: {
    marginBottom: '2px',
    whiteSpace: 'pre-wrap'
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: 'auto',
    gap: '16px'
  }
};

const mapStateToProps = (state: AppStoreState) => ({
  entity: state.entity
});

const withRedux = connect(mapStateToProps, {
  saveUserSetting
});

export default flow(withRedux)(SwitchEditionModal);
